<template>
  <div class="upload">
    <el-upload
      class="upload-demo"
      drag
      action="/"
      :on-change='onChange'
      :auto-upload='false'
      :show-file-list="false"
      accept=".xls, .xlsx"
      multiple>
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">只能上传.xls .xlsx文件</div>
    </el-upload>
    <div slot="tip" v-if='fileData && uploadChange == "1"'>{{ fileData.name }}</div>
    <el-progress :percentage="percentageNum" status="success" v-if="progressShow && uploadChange == '1'"></el-progress>
    <el-button type="text" style="position: absolute;top: 0;left: 445px;" @click="download" v-if="uploadChange != '4'">下载导入模板</el-button>
  </div>
</template>

<script>
import xlsx from 'xlsx';
import { getItemId,getUrlParam } from "@/libs/index";
import { platformEng } from "@/libs/filterall";
export default {
  name: "uploadBean",
  props: {
    uploadChange: String
  },
  data: function() {
    return {
      outputs: [], // 保存读取出来的数据
      fileData:'', // 保存选择的文件
      percentageNum: 0,
      progressShow: false,
      excelData: [
        '平台',
        '商品名称',
        'SKU信息',
        '商品链接',
        '产品信息',
        '标价',
        '标价限价',
        '到手价',
        '到手价限价',
        '店铺名称',
        '旺旺',
        '店铺性质',
        '参考销量',
      ],
      numData: [
        'A1',
        'B1',
        'C1',
        'D1',
        'E1',
        'F1',
        'G1',
        'H1',
        'I1',
        'J1',
        'K1',
        'L1',
        'M1',
      ],
      excelData2: [
        '店铺信息',
      ],
      numData2: [
        'A1',
      ],
      excelData3: [
        '平台',
        '店铺名称',
        '产品信息',
        '活动标价',
        '活动到手价',
        '开始时间',
        '结束时间',
      ],
      numData3: [
        'A1',
        'B1',
        'C1',
        'D1',
        'E1',
        'F1',
        'G1',
      ],
    };
  },
  methods: {
    // 下载模板
    download() {
      if (this.uploadChange == 3) {
        window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E5%93%81%E7%89%8C%E6%96%B9%E6%B4%BB%E5%8A%A8%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E5%BA%97%E9%93%BA%E6%A8%A1%E6%9D%BF.xlsx', '_blank'); // 新开窗口
      } else {
        window.open('https://hawksights.obs.cn-east-2.myhuaweicloud.com/system/%E8%BF%9D%E8%A7%84%E9%80%9A%E7%9F%A5%E5%A4%8D%E6%9F%A5%E8%A1%A8%E6%A0%BC%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF%20.xlsx', '_blank'); // 新开窗口
      }
    },
    // 文件选择回调
    onChange(file,fileList){
      this.percentageNum = 0
      this.progressShow = false
      this.fileData = file // 保存当前选择文件
      if (this.uploadChange == 3) {
        this.complexReadExcel()
      } else if (this.uploadChange == 4) {
        this.huoDongReadExcel()
      } else {
        this.readExcel() // 调用读取数据的方法
      }
    },
    huoDongReadExcel() {
      this.progressShow = true
      this.percentageNum = 30
      let that = this;
      const files = that.fileData;
      console.log(files);
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          // console.log(data)
          const workbook = xlsx.read(data, {
            type: "binary",
            cellDates: true,
          });
          // 判断表格数据是否正确
          for (var a = 0; a < 10; a++) {
            if (workbook.Sheets[workbook.SheetNames[0]][this.numData3[a]] && this.excelData3[a] !== workbook.Sheets[workbook.SheetNames[0]][this.numData3[a]].v) {
              this.$message({
                message: '导入表格表头与模板不匹配，请核对表格表头',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              return
            }
          }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.outputs = []; //清空接收数据
          // 修改数据类型
          for (var i = 0; i < ws.length; i++) {
            // console.log(ws[i].商品链接)
            // console.log(ws[i].平台)
            if (ws[i].店铺名称 === undefined) {
              that.$message({
                message: '导入表格第' + Number(i+1) +'条店铺名称为空，请先完善信息',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              this.fileData.name = ''
              return
            }
            var sheetData = {
              platform: ws[i]['平台'],
              shopname: ws[i]['店铺名称'],
              productname: ws[i]['产品信息'],
              price: ws[i]['活动标价'],
              availableprice: ws[i]['活动到手价'],
              begintime: this.formatDate(ws[i]['开始时间']),
              stoptime: this.formatDate(ws[i]['结束时间']),
            };
            that.outputs.push(sheetData);
          }
          if (that.outputs.length === 0) {
            that.$message({
              message: '导入表格为空',
              type: 'warning'
            });
            this.percentageNum = 0
            this.progressShow = false
            this.fileData.name = ''
            return
          }
          this.$emit("uploadBeanData", that.outputs);
          this.percentageNum = 100
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    formatDate(numb) {
      var date = new Date(numb);
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = date.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = date.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = date.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = date.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
    },
    complexReadExcel() {
      this.progressShow = true
      this.percentageNum = 30
      let that = this;
      const files = that.fileData;
      console.log(files);
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          // console.log(data)
          const workbook = xlsx.read(data, {
            type: "binary"
          });
          // 判断表格数据是否正确
          for (var a = 0; a < 10; a++) {
            if (workbook.Sheets[workbook.SheetNames[0]][this.numData2[a]] && this.excelData2[a] !== workbook.Sheets[workbook.SheetNames[0]][this.numData2[a]].v) {
              this.$message({
                message: '导入表格表头与模板不匹配，请核对表格表头',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              return
            }
          }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.outputs = []; //清空接收数据
          // 修改数据类型
          for (var i = 0; i < ws.length; i++) {
            // console.log(ws[i].商品链接)
            // console.log(ws[i].平台)
            if (ws[i].店铺信息 === undefined) {
              that.$message({
                message: '导入表格第' + Number(i+1) +'条店铺信息为空，请先完善信息',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              this.fileData.name = ''
              return
            }
            var sheetData = {
              shopName: ws[i]['店铺信息'],
            };
            that.outputs.push(sheetData);
          }
          if (that.outputs.length === 0) {
            that.$message({
              message: '导入表格为空',
              type: 'warning'
            });
            this.percentageNum = 0
            this.progressShow = false
            this.fileData.name = ''
            return
          }
          this.$emit("uploadBeanData", that.outputs);
          this.percentageNum = 100
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    },
    readExcel(e) {
      this.progressShow = true
      this.percentageNum = 30
      let that = this;
      const files = that.fileData;
      console.log(files);
      if (!files) {
        //如果没有文件
        return false;
      } else if (!/\.(xls|xlsx)$/.test(files.name.toLowerCase())) {
        this.$message.error("上传格式不正确，请上传xls或者xlsx格式");
        return false;
      }
      const fileReader = new FileReader();
      fileReader.onload = ev => {
        try {
          const data = ev.target.result;
          // console.log(data)
          const workbook = xlsx.read(data, {
            type: "binary"
          });
          // 判断表格数据是否正确
          for (var a = 0; a < 10; a++) {
            if (workbook.Sheets[workbook.SheetNames[0]][this.numData[a]] && this.excelData[a] !== workbook.Sheets[workbook.SheetNames[0]][this.numData[a]].v) {
              this.$message({
                message: '导入表格表头与模板不匹配，请核对表格表头',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              return
            }
          }
          const wsname = workbook.SheetNames[0]; //取第一张表
          const ws = xlsx.utils.sheet_to_json(workbook.Sheets[wsname]); //生成json表格内容
          that.outputs = []; //清空接收数据
          // 修改数据类型
          for (var i = 0; i < ws.length; i++) {
            // console.log(ws[i].商品链接)
            // console.log(ws[i].平台)
            if (ws[i].商品链接 === undefined) {
              that.$message({
                message: '导入表格第' + Number(i+1) +'条链接地址为空，请先完善信息',
                type: 'warning'
              });
              this.percentageNum = 0
              this.progressShow = false
              this.fileData.name = ''
              return
            }
            var sheetData = {
              itemlink:ws[i]['商品链接'],
            };
            if (platformEng(ws[i].平台)) {
              sheetData.platform = platformEng(ws[i].平台)
            }
            if (ws[i]['商品名称']) {
              sheetData.itemtitle = ws[i]['商品名称']
            }
            if (ws[i]['SKU信息']) {
              sheetData.skuname = ws[i]['SKU信息']
            }
            if (ws[i]['产品信息']) {
              sheetData.productname = ws[i]['产品信息']
            }
            if (ws[i]['标价']) {
              sheetData.bidprice = ws[i]['标价']
            }
            if (ws[i]['标价限价']) {
              sheetData.limitprices = ws[i]['标价限价']
            }
            if (ws[i]['到手价']) {
              sheetData.theirprice = ws[i]['到手价']
            }
            if (ws[i]['到手价限价']) {
              sheetData.theirlimitprice = ws[i]['到手价限价']
            }
            if (ws[i]['店铺名称']) {
              sheetData.shopname = ws[i]['店铺名称']
            }
            if (ws[i]['旺旺']) {
              sheetData.wangwang = ws[i]['旺旺']
            }
            if (ws[i]['店铺性质']) {
              sheetData.shoptype = ws[i]['店铺性质']
            }
            if (ws[i]['参考销量']) {
              sheetData.salevolume = ws[i]['参考销量']
            }
            if (getItemId(ws[i].商品链接)) {
              sheetData.itemid = getItemId(ws[i].商品链接)
            }

            if (getUrlParam(ws[i].商品链接, "skuid")) {
              sheetData.skuId = getUrlParam(ws[i].商品链接, "skuid")
            }
            that.outputs.push(sheetData);
          }
          console.log(that.outputs.length)
          if (that.outputs.length === 0) {
            that.$message({
              message: '导入表格为空',
              type: 'warning'
            });
            this.percentageNum = 0
            this.progressShow = false
            this.fileData.name = ''
            return
          }
          this.$emit("uploadBeanData", that.outputs);
          this.percentageNum = 100
          this.$refs.upload.value = "";
        } catch (e) {
          return false;
        }
      };
      // 如果为原生 input 则应是 files[0]
      fileReader.readAsBinaryString(files.raw);
    }
  }
};
</script>

<style lang="scss">
.upload {
  position: relative;
  .el-upload__tip {
    font-size: 12px;
    color: #999999;
    line-height: 25px;
  }
  .el-upload-dragger {
    width: 425px;
  }
}
</style>
